var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagram = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icons/instagram",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "InstagramLogo",
  transform: "translate(2.000000, 2.000000)",
  fill: "#009877",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Vector",
  transform: "translate(6.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.5,9 C1.96153846,9 0,6.92307692 0,4.5 C0,1.96153846 2.07692308,0 4.5,0 C7.03846154,0 9,2.07692308 9,4.5 C9,6.92307692 6.92307692,9 4.5,9 Z M4.5,1.38461538 C2.76923077,1.38461538 1.38461538,2.76923077 1.38461538,4.5 C1.38461538,6.23076923 2.76923077,7.5 4.5,7.5 C6.23076923,7.5 7.61538462,6.11538462 7.61538462,4.38461538 C7.61538462,2.65384615 6.11538462,1.38461538 4.5,1.38461538 Z",
  id: "Shape"
})), /*#__PURE__*/React.createElement("g", {
  id: "Vector_2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.3902439,20 L5.6097561,20 C2.43902439,20 0,17.4545455 0,14.4242424 L0,5.57575758 C0,2.54545455 2.43902439,0 5.6097561,0 L14.3902439,0 C17.4390244,0 20,2.54545455 20,5.57575758 L20,14.4242424 C20,17.4545455 17.4390244,20 14.3902439,20 Z M5.6097561,1.57575758 C3.41463415,1.57575758 1.58536585,3.39393939 1.58536585,5.57575758 L1.58536585,14.4242424 C1.58536585,16.6060606 3.41463415,18.4242424 5.6097561,18.4242424 L14.3902439,18.4242424 C16.5853659,18.4242424 18.4146341,16.6060606 18.4146341,14.4242424 L18.4146341,5.57575758 C18.4146341,3.39393939 16.5853659,1.57575758 14.3902439,1.57575758 L5.6097561,1.57575758 Z",
  id: "Shape"
})), /*#__PURE__*/React.createElement("g", {
  id: "Vector_3",
  transform: "translate(14.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.00954926,2 C1.62858097,2 2,1.5 2,1 C2,0.375 1.50477463,0 1.00954926,0 C0.514323886,0 0.0190985149,0.5 0.0190985149,1 C-0.104707828,1.5 0.390517543,2 1.00954926,2 Z",
  id: "Path"
}))))));
export { SvgInstagram as ReactComponent };
export default __webpack_public_path__ + "images/instagram.svg";